import {Link, useLocation, useNavigate} from "react-router-dom";
import {useEffect, useState, useRef, useMemo} from "react";
import {GetOrders} from "../api/orders";
import bus from "../icons/bus.svg"
import Moment from "react-moment";
import 'moment/locale/ru';
import moment from "moment";
import question from "../icons/question.svg"
import Index from '../components/header'
import Loader from "../components/loader";
import notFoundIcon from '../icons/notfound.svg'
import Header from "../components/header";
import Status from "../components/status";
import closeIcon from "../icons/close.svg";
import questionBigIcon from "../icons/question-big.svg";

const useOnScreen = (ref) => {

    const [isIntersecting, setIntersecting] = useState(false)

    const observer = useMemo(() => new IntersectionObserver(
        ([entry]) => setIntersecting(entry.isIntersecting)
    ), [ref])

    useEffect(() => {
        observer.observe(ref.current)
        return () => observer.disconnect()
    }, [])

    return isIntersecting
}

moment.calendarFormat = function (myMoment, now) {
    var diff = myMoment.diff(now, 'days', true);
    if (diff === 0) {
        return 'sameDay'
    }
    if (diff === -1) {
        return 'lastDay'
    }
    return 'sameElse'
};


const VehicleOrder = ({setEmail, order}) => {
    let navigate = useNavigate();
    return <>
    <div className={"orders-list-item-vehicle"} onClick={() => navigate("/order?orderId=" + order.id)}>
       <img style={{width: 24, height: 24}} src={bus}/>
    </div>
    <div className={"orders-list-item-info"} onClick={() => navigate("/order?orderId=" + order.id)}>
        <div className={"orders-list-item-route"}>{order.route?.number}</div>
        <div
            className={"orders-list-item-stations"}>{order.from_station?.name} {order.to_station ? <>&#8722;{order.to_station.name}</> : null}</div>
    </div>
    <div className={"orders-list-item-time"} onClick={() => navigate("/order?orderId=" + order.id)}>
        {new Date(order.created_at).getHours().toString().padStart(2, "0")}:{new Date(order.created_at).getMinutes().toString().padStart(2, "0")}
    </div>
    <div className={"orders-list-item-icon"} onClick={(e) => setEmail({
        email: (order.organization?.email || "support@sberintegro.ru") + "?subject=Вопрос по заказу " + order.id + "&body=%0A%0A%0A%0A------------------------------------------------------%0AПожалуйста, не удаляйте данные ниже.%0AЗаказ: " + order.id + "%0AUser-Agent: " + window.navigator.userAgent + "%0AВремя: " + new Date().toLocaleString(),
        label: order.organization?.email || "support@sberintegro.ru"
    })}>
        <img style={{width: 24, height: 24}} src={question}/>
    </div>
    </>
}

const Orders = () => {
    const ref = useRef()
    const scrolled = useOnScreen(ref)
    let navigate = useNavigate();
    const [orders, setOrders] = useState({})
    const [offset, setOffset] = useState(0)
    const [loading, setLoading] = useState(false)
    const [loadingAttempts, setLoadingAttempts] = useState(0)
    const [email, setEmail] = useState(null)
    const loadOrders = (data) => {
        setLoading(true)
        GetOrders(offset, 10).then(list => {
            setOrders(list.reduce((prev, item) => {
                const date = new Date(item.created_at).toISOString().split('T')[0]
                return {...prev, [date]: [...(prev[date] || []), item]}
            }, orders))
        }).finally(() => {
            setLoading(false)
            setLoadingAttempts(loadingAttempts + 1)
        })
    }

    useEffect(() => {
        loadOrders()
    }, [offset])

    useEffect(() => {
        if (scrolled && !loading) {
            setOffset(Object.keys(orders).reduce((prev, item) => prev + orders[item].length, 0))
        }
    }, [scrolled])

    return <div className={"page"} style={{overflow: "hidden", height: "100vh"}}>
        <Header title={"Мои поездки"} onBack={() => navigate("/?no_back=true")}/>
        {email && <div>
            <div style={{background: "#0000004D", position: "fixed", top: 0, left: 0, right: 0, bottom: 0}}></div>
            <div style={{
                background: "white",
                position: "fixed",
                borderTopLeftRadius: 16,
                borderTopRightRadius: 16,
                left: 0,
                right: 0,
                bottom: 0,
                height: 238,
                zIndex: 9999
            }}>
                <button onClick={() => setEmail(null)}
                        style={{position: "absolute", right: 16, top: 16, padding: 8, border: 0, background:"#F1F1F1", borderRadius: 8}}>
                    <img src={closeIcon} style={{display: "block"}}/>
                </button>
                <div style={{textAlign: "center", marginTop: 42}}>
                    <img src={questionBigIcon}/>
                    <div style={{
                        fontSize: 22,
                        lineHeight: "28px",
                        letterSpacing: "-0.018em",
                        textDecorationLine: "underline",
                        textDecorationStyle: "solid",
                        textUnderlinePosition: "from-font",
                        textDecorationSkipInk: "none",
                        marginTop: 8,

                    }}><a style={{color: "#1BA136"}} href={"mailto:" + email.email}>{email.label}</a></div>
                    <div style={{color:"#141414", marginTop:8, fontSize:14, letterSpacing:"-0.02em", lineHeight:"18px"}}>Техническая поддержка. Удерживайте ссылку<br/>для отправки письма</div>
                </div>

            </div>
        </div>}

        <div className={"orders"}>
            <Loader visible={loading}/>
            {!loading && loadingAttempts > 0 && Object.keys(orders).length === 0 &&
                <Status
                    icon={notFoundIcon}
                    title={"Нет купленных билетов"}
                    subtitle={<span>Здесь отображаются купленные билеты<br/>на общественный транспорт</span>}/>
            }
            <div className={"orders-list"}>
                {Object.keys(orders).map(date => <div key={date}>
                        <div className={"orders-list-date"}>
                            <div className={"orders-list-date-text"}>
                                <Moment locale="ru" calendar={{
                                    lastDay: '[Вчера]',
                                    sameDay: '[Сегодня]',
                                    sameElse: 'DD MMMM',
                                }}>{date}</Moment>
                            </div>
                        </div>

                        {orders[date].map(o => <div key={o.id} className={"orders-list-item"}>
                            <VehicleOrder setEmail={setEmail} order={o}/>
                        </div>)}
                    </div>
                )}
                <div style={{height: 160}} ref={ref}/>
            </div>
        </div>
    </div>
}


export default Orders